// export const BASE_URL_FOR_PATIENT = process.env.REACT_APP_API_BASE_URL;

export const DASHBOARD_API_BASSE_URL= "https://devteleraddashboard.azurewebsites.net"
const POST_SIGNUP_ROOT_URL_INVITATION =
  "https://alemhealthapi.azure-api.net/signup-invite";

const API_BASE_URL = "https://alemhealthapi.azure-api.net"
// Study endpoints
export const STUDY_API_BASE_URL = process.env.REACT_APP_STUDY_API_BASE_URL;
export const STUDY_ENDPOINT = STUDY_API_BASE_URL + "/api/studies/";
export const STUDY_UPLOAD_FACILITY_ENDPOINT =
  STUDY_ENDPOINT + "upload/facility/";
export const STUDY_UPLOAD_SELF_ENDPOINT = STUDY_ENDPOINT + "upload/";
export const STUDY_ZIP_FILE_ENDPOINT_SUFFIX = "/zip/";
export const STUDY_ACTIVITY_ENDPOINT_SUFFIX = "/timeline/";
export const STUDY_VIEWER_ENDPOINT_SUFFIX = "/viewer/";

export const PATIENT_API_BASE_URL = API_BASE_URL + process.env.REACT_APP_PATIENT_BASE_PREFIX
export const FRONT_DESK_API_BASE_URL = API_BASE_URL + process.env.REACT_APP_FRONT_DESK_BASE_PREFIX

// Dashboard api

export const STUDY_DASHBOARD_ENDPOINT = DASHBOARD_API_BASSE_URL+ "/api/studies/";
export const STUDY_HEARTBEAT_ENDPOINT = DASHBOARD_API_BASSE_URL+ "/heartbeat";
export const STUDY_SECURED_HEARTBEAT_ENDPOINT = DASHBOARD_API_BASSE_URL+ "/secured/heartbeat";
export const STUDY_UTILIZATION_SECURED_HEARTBEAT_ENDPOINT = DASHBOARD_API_BASSE_URL+ "/utilization/secured/heartbeat";
export const STUDY_UTILIZATION_RATES_ENDPOINT = DASHBOARD_API_BASSE_URL+ "/api/utilization/rates/study";
export const STUDY_UTILIZATION_RATES_PROCEDURE_ENDPOINT = DASHBOARD_API_BASSE_URL+ "/api/utilization/rates/procedures";


// Study Sharing Endpoints
export const BURN_CD_REQUEST_ENDPOINT = 'http://localhost:8088/api/box/studies/'

export const STUDY_LOCATION_ENDPOINT = process.env.REACT_APP_LOCATION_API_BASE_URL + '/api/studies/'
export const STUDY_DOWNLOAD_ZIP_FILE_TO_REMOTE_LOCATION_ENDPOINT_SUFFIX = '/download-request/'

// Study Sharing Endpoints
export const STUDY_SHARE_API_BASE_URL = process.env.REACT_APP_STUDY_SHARE_API_BASE_URL
export const STUDY_SHARE_ENDPOINT = STUDY_SHARE_API_BASE_URL + '/api/studies/'
export const STUDY_SHARE_REQUEST_ENDPOINT = API_BASE_URL + '/study-sharing-request/api/study-sharing/apply-request/'
export const STUDY_SHARING_REQUEST_ENDPOINT = API_BASE_URL + '/study-sharing-request/api/study-sharing'


// New Study Upload Endpoints
export const STUDY_DICOM_UPLOAD_BASE_URL =
  process.env.REACT_APP_DICOM_UPLOAD_BASE_URL;
export const STUDY_DICOM_UPLOAD_CONFIGURATION_ENDPOINT =
  STUDY_DICOM_UPLOAD_BASE_URL + "/api/new-study/dicom-uploads/configuration";

// Study Search
export const STUDY_SEARCH_BASE_URL =
  process.env.REACT_APP_STUDY_SEARCH_BASE_URL;
export const STUDY_LIST_ENDPOINT =
  STUDY_SEARCH_BASE_URL + "/search/study/approved-facilities/";
export const STUDY_SHARE_LIST_ENDPOINT =
  STUDY_SEARCH_BASE_URL + "/search/study/shared-with-me/";
export const MY_UPLOADS_ENDPOINT =
  STUDY_SEARCH_BASE_URL + "/search/study/my-uploads/";
export const WORK_LIST_ENDPOINT =
  STUDY_SEARCH_BASE_URL + "/search/assignment/work-list/";
export const STUDY_PRIORS_LIST_ENDPOINT =
  STUDY_SEARCH_BASE_URL + "/search/study/";
export const STUDY_PRIORS_LIST_ENDPOINT_SUFFIX = "/priors/";

export const ASSIGNMENT_ENDPOINT =
  process.env.REACT_APP_ASSIGNMENT_API_BASE_URL + "/api/assignments/";

// Report
export const REPORT_ENDPOINT =
  process.env.REACT_APP_REPORT_API_BASE_URL + "/api/reports/";
export const REPORT_SAVE_DRAFT_ENDPOINT_SUFFIX = "/draft/";
export const REPORT_PRELIMINARY_ENDPOINT_SUFFIX = "/preliminary/";
export const REPORT_SIGN_ENDPOINT_SUFFIX = "/final/";
export const REPORT_VERSIONED_ENDPOINT_SUFFIX = "/versions/";
export const REPORT_REVISE_ENDPOINT_SUFFIX = "/revise/";

export const REPORT_TEMPLATE_ENDPOINT =
  API_BASE_URL + "/templates/report-template";
export const TEMPLATES_ENDPOINT = API_BASE_URL + "/templates/report-templates";
export const REPORT_PDF_ENDPOINT_SUFFIX = "/pdf/";
export const ADDITIONAL_INFO_FOR_REPORT_PRINT_ENDPOINT =
  API_BASE_URL + "/reportprint/";
export const PREVIEW_REPORT_PRINT_ENDPOINT = API_BASE_URL + '/print-preview/api/report-print/'   

// Facility
export const INTERNAL_SOURCE_FACILITY_ENDPOINT =
  API_BASE_URL + "/ahfacility/facilities/approved-facilities";
export const EXTERNAL_SOURCE_FACILITY_ENDPOINT =
  API_BASE_URL + "/ahfacility/facilities/external/condensed";
export const FACILITY_ENDPOINT = API_BASE_URL + "/ahfacility/facility";
export const DEVICES_AS_HUB_ENDPOINTS = API_BASE_URL + "/devices/device/hub";

// Physician
export const PHYSICIANS_ENDPOINT = API_BASE_URL + "/ahphysician/api/";

// Patient API
export const PATIENT_ENDPOINT = PATIENT_API_BASE_URL + "/patient";
export const APPOINTMENT_BOOKING_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/appointment-booking";

// Frontdesk API
export const CONTACT_INFORMATION_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/contactinformation";
export const REFERRAL_DETAILS_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/referraldetails";
export const APPOINTMENT_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/appointment";
export const DELETE_APPOINTMENT_ENDPOINT = FRONT_DESK_API_BASE_URL + "/appointment/";
export const PATIENT_DETAIL_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/patient-detail";
export const SCHEDULE_DEVICE_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/schedule-device";
export const MODALITY_DEVICE_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/user/modality";
export const SERVICE_DEVICE_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/user/services";
export const USER_PROFILE_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/user";
export const APPOINTMENT_PATIENT_ENDPOINT = FRONT_DESK_API_BASE_URL + "/appointment";
export const MODALITY_DEVICES_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/user/modality";
export const PATIENT_SEARCH_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/patient/search";
export const modality_devices = 'https://alemhealthapi.azure-api.net/devices/'

// Medical
export const MEDICAL_HISTORY_ENDPOINT = FRONT_DESK_API_BASE_URL + "/api/v2.0/medicalhistory";

//SIGNUP
export const INVITE_RADIOLOGIST_ENDPOINT =
  API_BASE_URL + "/signup/email/invites/";
export const GET_INVITED_RADIOLOGIST_ENDPOINT =
  API_BASE_URL + "/signup-invite/api/";
export const NON_ADMIN_INVITE_RADIOLOGIST_ENDPOINT =
  POST_SIGNUP_ROOT_URL_INVITATION + "/api/organization/";

//UPLOAD FACILITY LOGOS 
export const SAS_TOKEN_ENDPOINT = API_BASE_URL + '/teleradsetting/api/options/blob-access/facility'
 
// Organization, User settings
export const GROUP_ENDPOINT = API_BASE_URL + "/teleradsetting/api/group";
export const PROVIDERS_AGGREGATED_ENDPOINT =
  API_BASE_URL + "/teleradsetting/api/providers/get/aggregate";
export const GET_USER_PROFILE_ENDPOINT =
  API_BASE_URL + "/teleradsetting/api/users";
export const PATCH_USER_PROFILE_ENDPOINT =
  API_BASE_URL + "/teleradsetting/api/users/existing";
export const RESET_PASSWORD_ENDPOINT =
  API_BASE_URL + "/teleradsetting/api/users/reset-password";
export const RESEND_VERIFICATION_EMAIL_ENDPOINT =
  API_BASE_URL + "/teleradsetting/api/users/verification-email";
export const PAYMENTS_ENDPOINT = API_BASE_URL + "/teleradsetting/api/payments";
export const PAYMENTS_DOWNGRADE_FREE_TIER_ENDPOINT =
  PAYMENTS_ENDPOINT + "/downgrade/free-tier";
export const DASHBOARD_STUDY_DETAILS_ENDPOINT =
  API_BASE_URL + "/dashboard/study-details/";
export const USER_LOCATION_ENDPOINT = "https://ipinfo.io/json";

// 3rd Party Services
export const INVITE_FACILITY_ENDPOINT =
  "https://hooks.zapier.com/hooks/catch/599828/ohxfqws/";
export const FORM_IO_ENDPOINT_PREFIX = "https://qvcdfudfjgqrrun.form.io/";
export const FORM_IO_LOGIN_ENDPOINT_SUFFIX = "user/login";
export const FORM_IO_SUBMISSION_ENDPOINT_SUFFIX = "/submission";

export const SIGN_UP_URL = process.env.REACT_APP_SIGNUP_URL;
export const FORGOT_PASSWORD_ENDPOINT_SUFFIX = "/dbconnections/change_password";

// Not in use
export const CONFIGURATION_ENDPOINT = API_BASE_URL + "/configurations/";
export const NOTIFICATION_ENDPOINT = API_BASE_URL + "/timeline/";
export const AUTH0_AZURE_DELEGATION_ENDPOINT = "/delegation";

export const SECONDS_IN_A_MINUTE = 60;
export const SECONDS_IN_HALF_OF_A_MINUTE = 30;
export const MILLISECONDS_IN_A_MINUTE = SECONDS_IN_A_MINUTE * 1000;
export const MILLISECONDS_IN_HALF_MINUTE = SECONDS_IN_HALF_OF_A_MINUTE * 1000;
export const DATA_POLL_REFRESH_DELAY = 2 * MILLISECONDS_IN_A_MINUTE;
export const DATA_POLL_REFRESH_SHORT_DELAY = MILLISECONDS_IN_HALF_MINUTE;
export const REFRESH_TOKEN_WAIT_TIME = 60 * SECONDS_IN_A_MINUTE;

// Report
export const CLOUD_ENDPOINT = process.env.REACT_APP_UPPY_UPLOAD_BASE_URL;
export const CLOUD_UPPY_ENDPOINT = CLOUD_ENDPOINT + "/api/new-study/uppy/";
export const CLOUD_UPLOAD_CONFIGURATION_ENDPOINT =
  CLOUD_ENDPOINT + "/api/new-study/uppy/upload-configuration/";
export const CLOUD_DICOM_UPLOAD_ENDPOINT =
  CLOUD_ENDPOINT + "/api/dicom-uploads/uppy/import-finished/upload-url/";

// Medicial Group
export const MEDICAL_GROUP_INVITATION_ENDPOINT =
  POST_SIGNUP_ROOT_URL_INVITATION + "/api/invitations/user/";
export const MEDICAL_GROUP_INVITATION_DOMAIN_ENDPOINT =
  POST_SIGNUP_ROOT_URL_INVITATION + "/api/organization/domains/";
export const MEDICAL_GROUP_ACCESS_REQUEST_ENDPOINT =
  POST_SIGNUP_ROOT_URL_INVITATION + "/api/organization/";
export const MEDICAL_GROUP_ACCEPT_INVITATION_REQUEST_ENDPOINT =
  POST_SIGNUP_ROOT_URL_INVITATION + "/api/invitations/";

//ONBOARDING
export const EMBED_API_BASE_URL = API_BASE_URL + "/embed";
export const EMAIL_TEMPLATE_ENDPOINT =
  API_BASE_URL + "/signup/email/templated/";
export const OPTIONS_ENDPOINT = API_BASE_URL + "/teleradsetting/api/options";
export const ORDER_HARDWARE_ENDPOINT =
  "https://hooks.zapier.com/hooks/catch/599828/ozjfjs2/";
export const ZAPIER_INVITE_SIGN_UP_WEB_HOOK =
  "https://hooks.zapier.com/hooks/catch/599828/ba95rre/";
export const ZAPIER_SHARE_STUDY_WEB_HOOK =
  "https://hooks.zapier.com/hooks/catch/599828/ba8i92c/";
export const PHYSICIANS_API_BASE_URL = API_BASE_URL + "/ahphysician";
export const INVITE_RADIOLOGIST_API_BASE_URL =
  API_BASE_URL + "/teleradsetting/api/internal-radiologists";

// LanguageList
export const COUNTRY_LIST_ENDPOINT = "https://restcountries.com/v2/all";

// Zapier
export const ZAPIER_EDNPOINT =
  "https://hooks.zapier.com/hooks/catch/599828/ozjfjs2/";
export const ZAPIER_TRIAL_END_EDNPOINT =
  "https://hooks.zapier.com/hooks/catch/599828/bqtoj0u/";

  export const ZAPIER_NOTIFICATION_SUGGESTION_ENDPOINT = "https://hooks.zapier.com/hooks/catch/599828/bp2khck/"

  console.log(`API Base URL: ${API_BASE_URL}.`);
  console.log("Environment: ", process.env.REACT_APP_ENV);
  console.log(`Patient API Base URL: ${PATIENT_API_BASE_URL}`);
  console.log(`Appointment Booking Base URL: ${APPOINTMENT_BOOKING_ENDPOINT}`);
  console.log(`FrontDesk API Base URL: ${FRONT_DESK_API_BASE_URL}`);
  console.log(`Patient API Endpoint: ${PATIENT_ENDPOINT}`);
  console.log(`Appointment API Endpoint: ${APPOINTMENT_ENDPOINT}`);
  console.log("Version: ", process.env.REACT_APP_VERSION);
